import i18next from 'i18next';
import { FeedableEditDropdownEnum, FeedableEditMetaValue } from 'types/graphql';

export const shiftTypeDetailsMapper: Record<
  FeedableEditDropdownEnum,
  (shiftEdit: FeedableEditMetaValue) => string
> = {
  dropdown: (shiftEdit: FeedableEditMetaValue) =>
    `${shiftEdit.fieldName} ${i18next.t('shifts_calendar:FROM')} "${
      shiftEdit.oldValuePretty
    }" ${i18next.t('shifts_calendar:TO')} "${shiftEdit.newValuePretty}"`,

  text_area: (shiftEdit: FeedableEditMetaValue) =>
    `${shiftEdit.fieldName} ${i18next.t('shifts_calendar:MODIFIED')}`,
  input: (shiftEdit: FeedableEditMetaValue) =>
    `${shiftEdit.fieldName} ${i18next.t('shifts_calendar:MODIFIED')}`,
  checkbox: (shiftEdit: FeedableEditMetaValue) =>
    `${shiftEdit.fieldName} ${i18next.t('shifts_calendar:MODIFIED')}`,
};
